(() => {
  if (customElements.get('reviewsio-rating')) return;

  const CACHE_TTL = 60 * 60 * 1000; // 1 hour

  class ReviewsIORating extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.load();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    async load() {
      const store = this.getAttribute('store');
      if (!store) return;

      const cacheKey = `reviewsio-rating:${store}`;
      const cached = this.readCache(cacheKey);

      if (cached) {
        this.render(cached);
        return;
      }

      try {
        const response = await fetch(
          `https://api.reviews.io/merchant/reviews?store=${encodeURIComponent(store)}&per_page=1`,
          { signal: this.abortController.signal }
        );
        if (!response.ok) return;

        const { stats } = await response.json();
        const rating = Number.parseFloat(stats?.average_rating);
        const count = Number.parseInt(stats?.total_reviews, 10);
        if (!rating || !count) return;

        this.writeCache(cacheKey, { rating, count });
        this.render({ rating, count });
      } catch {
        // Keep the server-rendered fallback values
      }
    }

    render({ rating, count }) {
      const locale = document.documentElement.lang || undefined;
      const formattedRating = rating.toLocaleString(locale, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 2
      });

      const ratingElement = this.querySelector('[data-rating-value]');
      const countElement = this.querySelector('[data-rating-count]');
      const labelElement = this.querySelector('[data-rating-label]');

      if (ratingElement) ratingElement.textContent = formattedRating;
      if (countElement) countElement.textContent = count.toLocaleString(locale);
      if (labelElement) labelElement.setAttribute('aria-label', `${formattedRating} / 5`);
    }

    readCache(key) {
      try {
        const entry = JSON.parse(sessionStorage.getItem(key));
        if (entry && Date.now() - entry.timestamp < CACHE_TTL) return entry.stats;
      } catch {
        // Ignore unreadable cache entries
      }
      return null;
    }

    writeCache(key, stats) {
      try {
        sessionStorage.setItem(key, JSON.stringify({ timestamp: Date.now(), stats }));
      } catch {
        // Storage may be unavailable (private mode, quota)
      }
    }
  }

  customElements.define('reviewsio-rating', ReviewsIORating);
})();
